


















import Vue from 'vue';
import VSwatches from 'vue-swatches';
import { hex2rgba } from '@/core/api/utils/color-converter.ts';

export default Vue.extend({
  name: 'ColorPicker',
  components: { VSwatches },
  props: {
    value: String,
  },
  computed: {
    color: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', this.validateColor(value));
      },
    },
  },
  methods: {
    convertHex2rgba(color, opacity) {
      return hex2rgba(color, opacity);
    },
    isValidColor(color) {
      if (!color) return false;
      if (!('CSS' in window) || !('supports' in window.CSS)) {
        // fallback for not supported browsers
        const s = new Option().style;
        s.color = color;
        return s.color !== '';
      } else {
        // https://developer.mozilla.org/en-US/docs/Web/API/CSS/supports
        return CSS.supports('color', color);
      }
    },
    validateColor(color) {
      if (!color) return color;
      if (!this.isValidColor(color)) {
        const hashedColor = `#${color}`;
        if (this.isValidColor(hashedColor)) {
          return hashedColor;
        }
      }
      return color;
    },
  },
});
